import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { CheckBoxBigGrayIcon } from '../../../icon/icon';
import { useHistory } from 'react-router-dom';

const radioBtnItems = [
  { key: 'belonged', value: '일대차' },
  { key: 'rent', value: '마당차' },
];

interface ConfirmModalProps {
  handleConfirmClose: () => void;
  confirmText?: string;
  onClick?: () => void;
}

export const DairyTypeModal = ({
  handleConfirmClose,
  onClick,
}: ConfirmModalProps) => {
  const history = useHistory();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      type: 'belonged',
    },
  });
  const onSubmit = (data: any) => {
    if (data.type === 'belonged') {
      history.push({
        pathname: '/userDiary/belonged/regist',
        state: { selectedType: data.type, borderLine: true },
      });
    } else {
      history.push({
        pathname: '/userDiary/rent/regist',
        state: { selectedType: data.type, borderLine: true },
      });
    }
  };
  return (
    <ModalContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        type: 'fade',
      }}
    >
      <div className="overlay" onClick={handleConfirmClose}></div>
      <ModalInner
        className="wrapper"
        initial={{ y: '100%' }}
        animate={{ y: '0%' }}
        exit={{ y: '100%' }}
        transition={{
          type: 'spring',
          stiffness: 400,
          damping: 40,
        }}
      >
        <div className="modal-head">일보 종류 선택</div>
        <div className="modal-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <RadioBtnBox>
              {radioBtnItems.map((item) => (
                <div key={item.key} className="radio-btn-box">
                  <input
                    type="radio"
                    value={item.key}
                    id={item.key}
                    {...register('type')}
                  />
                  <label htmlFor={item.key}>
                    <span className="icon-box">
                      <CheckBoxBigGrayIcon />
                    </span>
                    {item.value}
                  </label>
                </div>
              ))}
            </RadioBtnBox>
            <div className="btn-box">
              <button
                type="button"
                onClick={handleConfirmClose}
                className="first-btn"
              >
                취소
              </button>
              <button className="second-btn">선택</button>
            </div>
          </form>
        </div>
      </ModalInner>
    </ModalContainer>
  );
};

// style
const ModalContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2.6rem;
  cursor: 'pointer';
  width: 100%;
  height: 100%;
  .overlay {
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
`;

const ModalInner = styled(motion.div)`
  position: relative;
  z-index: 99;
  background-color: ${(props) => props.theme.textWhiteColor};
  width: 100%;
  min-height: 23.4rem;
  border-radius: 1.6rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  .modal-head {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    font-size: 1.8rem;
    font-weight: 700;
  }
  .modal-body {
    margin-top: 2.7rem;
    flex: 1 1 auto;
    width: 100%;
    .btn-box {
      margin-top: 2.8rem;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.8rem;
      button {
        width: 100%;
        background-color: ${(props) => props.theme.btnBlueColor};
        color: ${(props) => props.theme.textWhiteColor};
        border-radius: 0.8rem;
        border: 0;
        outline: none;
        font-size: 1.8rem;
        font-weight: 500;
        padding: 1.3rem 1rem;
        height: 4.6rem;
      }
      .first-btn {
        background-color: ${(props) => props.theme.logoutBtnBgColor};
        color: ${(props) => props.theme.gray900};
      }
      .second-btn {
        background-color: ${(props) => props.theme.btnBlueColor};
        color: ${(props) => props.theme.textWhiteColor};
      }
    }
  }
`;

const RadioBtnBox = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 0 0.5rem;
  .radio-btn-box {
    display: flex;
    align-items: center;
    height: 12rem;
    flex: 1 0 auto;
    input[type='radio'] {
      display: none;
    }
    label {
      border: 1px solid ${(props) => props.theme.gray700};
      border-radius: 1.6rem;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 1.8rem;
      font-weight: 600;
      line-height: 2.2rem;
      position: relative;
      color: ${(props) => props.theme.gray700};
    }
    input[type='radio']:checked + label {
      border: 1px solid ${(props) => props.theme.btnBlueColor};
      color: ${(props) => props.theme.btnBlueColor};
      .icon-box {
        svg {
          circle {
            fill: ${(props) => props.theme.btnBlueColor};
          }
          path {
            fill: ${(props) => props.theme.textWhiteColor};
          }
        }
      }
    }
  }
`;
